export default {"src":"/_next/static/media/icon-short-skill-description.5b5b51b3.svg","height":6,"width":15,"blurWidth":0,"blurHeight":0};